import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { updateModal } from '../store/slices/modalSlice';
import { Modal } from 'react-bootstrap';
import FormComponent from './FormComponent';
import { pattern } from '../config/constant';
import Swal from 'sweetalert2';

function EnquiryForm() {
    const dispatch = useDispatch();
    const modalValue = useSelector((state) => state.modal.value);
    const [loader, setLoader] = useState(false);
    const sendFormData = (data) => {
        const url = "https://script.google.com/macros/s/AKfycbzKgJIJew7uSZGwC8KtYi3OTJBUG8GwKJzFgmTEq16B_XlYk5r-cAHtNva3k9erM0Ha/exec"
        fetch(url, {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: (`Name=${data?.name ?? ""}&Email=${data?.email ?? ""}&Mobile=${data?.mobile ?? ""}&Message=${data?.message ?? ""}`)
        })
            .then(res => res.text())
            .then(data => {
                // console.log("data::", data);
                // alert(data)
                setLoader(false);
                dispatch(updateModal(false))
                Swal.fire({
                    title: "Enquiry Submitted!",
                    text: "Thank you for your interest in our paper cups! We’ll get back to you shortly.",
                    icon: "success",
                    confirmButtonText: "OK",
                });
            })
            .catch(error => {
                console.log(error)
                setLoader(false);
            })
    }

    return (
        <div>
            <Modal
                show={modalValue}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                onHide={() => { dispatch(updateModal(false)) }}>
                <Modal.Header closeButton>
                    <Modal.Title>Enquiry Form</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <FormComponent
                        // action={frontEnd_API.postAddress}
                        onSubmit={(e) => {
                            sendFormData(e)
                            setLoader(true);
                        }}
                        submitFullWidth={true}
                        submitBTNAlign={'justify-content-start'}
                        formMessage={"New Address Added !"}
                        button={"Send Enquiry"}
                        loader={loader}
                        fields={[
                            {
                                divClass: 'col-12',
                                name: 'Name',
                                key: 'name',
                                required: true,
                            },
                            {
                                type: 'email',
                                divClass: 'col-12',
                                name: 'Email',
                                key: 'email',
                                required: true,
                                pattern: pattern.email
                            },
                            {
                                type: 'number',
                                divClass: 'col-12',
                                name: 'Mobile',
                                key: 'mobile',
                                required: true,
                                pattern: pattern.mobile
                            },
                            {
                                type: "textarea",
                                divClass: 'col-12',
                                name: 'your message',
                                key: 'message',
                                required: true,
                            }
                        ]}
                    />
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default EnquiryForm